import { spaceMixin, Upsell } from '@zillow/constellation';
import styled from 'styled-components';

export const StyledUpsell = styled(Upsell)`
  display: flex;
  flex: 1;
  margin: ${spaceMixin('xs')};
`;
